module.exports = __webpack_public_path__ + "img/horizontal_3_1_pp1_7005.d45c96bf.png";